import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// ?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_before_after_start~1
		'main-walking': {
			landing: {
				ids: ['loader-walking', 'social-proof', 'age-walking'],
			},
		},
		// ?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_before_after_start~1
		main: {
			landing: {
				ids: ['loader-main', 'social-proof', 'age-main'],
			},
		},
		// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_before_after_start~1
		'activity-female-tai-chi-walking-v2-al': {
			landing: {
				ids: ['loader-tai-chi-walking-f', 'social-proof-tai-chi', 'age-tai-chi-walking-f'],
			},
		},
	},
]

export default config
